import { AbstractControl, ValidationErrors } from '@angular/forms';
import { esFechaFuturaEnArgentina } from './models/notificacion-institucional.model';

/** Válido si está vacío (la obligatoriedad la controla otro validador) o si es una fecha futura en horario Argentina. */
export function fechaFuturaArgentinaValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  return esFechaFuturaEnArgentina(control.value) ? null : { fechaNoFutura: true };
}

const URL_MAXIMO = 2000;
const PREFIJO_HTTPS = 'https://';
// Mismo patrón que PATRON_DOMINIO del back (notificaciones-service): tramos
// alfanuméricos (con guiones internos) separados por punto y TLD de 2+ letras.
const PATRON_DOMINIO = /^([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i;
const TEXTO_BOTON_MAXIMO = 25;

/** Devuelve el mensaje de error de la URL del enlace, o null si es válida. Mismas reglas y mensajes que el back. */
export function validarUrlExterna(destino: string | null | undefined): string | null {
  if (!destino || !destino.trim()) {
    return 'La URL del enlace es obligatoria.';
  }
  const url = destino.trim(); // el back también hace trim antes de validar
  if (url.length > URL_MAXIMO) {
    return `La URL del enlace no puede superar los ${URL_MAXIMO} caracteres.`;
  }
  if (!url.toLowerCase().startsWith(PREFIJO_HTTPS)) {
    return 'La URL del enlace debe empezar con https://.';
  }
  if (!esUrlBienFormada(url)) {
    return 'La URL del enlace no tiene un formato válido.';
  }
  return null;
}

function esUrlBienFormada(url: string): boolean {
  try {
    return PATRON_DOMINIO.test(new URL(url).hostname);
  } catch {
    return false; // new URL() lanza si la URL no se puede parsear
  }
}

/** Devuelve el mensaje de error del texto del botón, o null si es válido. Mismas reglas y mensajes que el back. */
export function validarTextoBoton(texto: string | null | undefined): string | null {
  if (!texto || !texto.trim()) {
    return 'El texto del botón es obligatorio.';
  }
  if (texto.trim().length > TEXTO_BOTON_MAXIMO) {
    return `El texto del botón no puede superar los ${TEXTO_BOTON_MAXIMO} caracteres.`;
  }
  return null;
}

// Wrappers de Angular: el error lleva el mensaje listo para mostrar en el template.
export function urlExternaValidator(control: AbstractControl): ValidationErrors | null {
  const mensaje = validarUrlExterna(control.value);
  return mensaje ? { urlEnlace: mensaje } : null;
}

export function textoBotonValidator(control: AbstractControl): ValidationErrors | null {
  const mensaje = validarTextoBoton(control.value);
  return mensaje ? { textoBotonEnlace: mensaje } : null;
}
